exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "stage-config-field {\n  display: block;\n}\nstage-config-field label {\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/pipeline/config/stages/core/stageConfigField/stageConfigField.directive.less
// module id = 2942
// module chunks = 0